import { IPScrollablePane } from 'baseComponents';
import { IPScrollbarVisibility } from 'baseComponents/ScrollablePane/IPScrollablePane';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackItemStylesPaddingSceneScroll, globalStackTokensGapSmall } from 'globalStyles';
import Tag from 'models/tag';
import Task from 'models/tasks/task';
import { TaskState } from 'models/tasks/taskHelperClasses';
import { TaskDetailAssignment } from './Details/TaskDetailAssignment';
import { TaskDetailDeadline } from './Details/TaskDetailDeadline';
import { TaskDetailDescription } from './Details/TaskDetailDecription';
import { TaskDetailExternalId } from './Details/TaskDetailExternalId';
import { TaskDetailName } from './Details/TaskDetailName';
import { TaskDetailRecurrence } from './Details/TaskDetailRecurrence';
import { TaskDetailStart } from './Details/TaskDetailStart';
import { TaskDetailStatus } from './Details/TaskDetailStatus';
import { TaskDetailTags } from './Details/TaskDetailTags';

interface INormalTaskDetail {
  task: Task;
  orgTask: Task;
  getErrorMessage: (field: string) => string | undefined;
  onUpdate: (newTask: Task) => void;
  taskStates: TaskState[];
  isActionPending: boolean;
  loadRescheduleRange: () => void;
  tags: Tag[];
  addTagToTaskState: (tag: Tag) => void;
  removeTagFromTaskState: (tag: Tag) => void;
  onChangeCompletionDate: (completionDate: Date) => void;
  canUpdate: boolean;
  compactView: boolean | undefined;
}

export const NormalTaskDetail = (props: INormalTaskDetail) => {
  return (
    <IPStack verticalFill tokens={globalStackTokensGapSmall}>
      <IPStack.Item grow styles={globalStackItemStylesPaddingSceneScroll}>
        <IPScrollablePane scrollbarVisibility={IPScrollbarVisibility.auto}>
          <IPStack verticalFill tokens={globalStackTokensGapSmall} styles={{ root: { paddingRight: 10 } }}>
            <TaskDetailName
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
              getErrorMessage={props.getErrorMessage}
              compactView={props.compactView}
            />
            <TaskDetailTags
              orgTask={props.orgTask}
              task={props.task}
              tags={props.tags}
              canUpdate={props.canUpdate}
              addTagToTaskState={props.addTagToTaskState}
              removeTagFromTaskState={props.removeTagFromTaskState}
              isActionPending={props.isActionPending}
            />
            <TaskDetailDescription
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
            />
            <TaskDetailAssignment
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
              getErrorMessage={props.getErrorMessage}
            />
            <TaskDetailStatus
              task={props.task}
              orgTask={props.orgTask}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
              onChangeCompletionDate={props.onChangeCompletionDate}
              showCompleted={true}
            />
            <TaskDetailStart
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
              getErrorMessage={props.getErrorMessage}
              loadRescheduleRange={props.loadRescheduleRange}
            />
            <TaskDetailDeadline
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
              getErrorMessage={props.getErrorMessage}
            />
            <TaskDetailRecurrence
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
            />
            <TaskDetailExternalId
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
            />
          </IPStack>
        </IPScrollablePane>
      </IPStack.Item>
    </IPStack>
  );
};
